import { useRedux } from 'hooks';
import { useEffect, useState } from 'react';
import { Card, Col, Form, Modal, Row } from 'react-bootstrap';
import { FormInput } from 'components';
import { useForm } from 'react-hook-form';
import { companySortCodesSelector } from 'redux/selectors/domains';
import { makeDomainsOptions } from 'redux/domains/utils';
import { ButtonWithLoading } from 'components/custom/button/ButtonWithLoad';
import '../container-sort.css';
import { SortApiService } from '../service/SortApiService';
import showToast from 'utils/notification';

interface Props {
    show: boolean;
    payload?: any;
    toggle: () => void;
    updateTable: () => void;
    isMinimalistTable?: boolean;
}

export type FormInputs = {
    sortCodeIds: string;
    name: string;
};

const AddSortCodeConfig = (props: Props) => {
    const { appSelector } = useRedux();
    const { setValue, register, watch, formState, handleSubmit } = useForm<FormInputs>();
    const companySortCodes = appSelector(companySortCodesSelector) || [];

    const companySortCodeOptions = companySortCodes.map(makeDomainsOptions({ label: 'text', value: 'value' }));

    useEffect(() => {
        if (props.payload) {
            setValue('sortCodeIds', props.payload.sortCodeIds.split(","));
            setValue('name', props.payload.name);
        }
    }, [props.payload, setValue]);

    const [loading, setLoading] = useState(false);

    const onClosePopup = () => {
        props.toggle();
    };

    const sortCodeConfigService = SortApiService();

    const onSubmitAddNewSortGroup = (data: FormInputs) => {
        setLoading(true);

        data.sortCodeIds = Array.isArray(data.sortCodeIds) ? data.sortCodeIds.join(',') : data.sortCodeIds;

        let sortCodeIdsArray: number[] = data.sortCodeIds
            .split(',')
            .map(id => Number(id.trim()))
            .filter(n => !isNaN(n));

        if (props.payload) {
            updateSortCodeConfig(props.payload.id, data.name, sortCodeIdsArray);
        } else {
            addSortCodeConfig(data.name, sortCodeIdsArray);
        }
    };

    const addSortCodeConfig = (name: string, sortCodeIds: number[]) => {
        sortCodeConfigService
            .addSortConfig(name, sortCodeIds)
            .then(() => {
                showToast('success', 'Sort group created successfully');
                setLoading(false);
                onClosePopup();
                props.updateTable();
            })
            .catch(() => {
                showToast('error', 'Error creating sort group');
                setLoading(false);
            });
    }

    const updateSortCodeConfig = (id: number, name: string, sortCodeIds: number[]) => {
        sortCodeConfigService
            .updateSortConfig(id, name, sortCodeIds)
            .then(() => {
                showToast('success', 'Sort group created successfully');
                setLoading(false);
                onClosePopup();
                props.updateTable();
            })
            .catch(() => {
                showToast('error', 'Error creating sort group');
                setLoading(false);
            });
    }

    return (
        <Modal
            show={props.show}
            onHide={onClosePopup}
            dialogClassName={'modal-right'}
            size="lg"
            className="notes-dialog">
            <div className="container mt-2">
                <h3 className="modal-title modal-title-new-pricing-rule">
                    {props.payload ? 'Update Sort Group' : 'Add New Sort Group'}
                </h3>
                <button type="button" className="btn-close" aria-label="Close" onClick={onClosePopup}></button>
            </div>
            <Modal.Body>
                <Card className="custom-pricing-rule">
                    <Card.Body>
                        <Row>
                            <Form onSubmit={handleSubmit(onSubmitAddNewSortGroup)}>
                                <Row className="align-items-center mb-3">
                                    <Col lg={12} sm={12}>
                                        <Form.Group className="mt-2">
                                            <FormInput
                                                name="name"
                                                label="Name"
                                                type="text"
                                                placeholder="Enter Name"
                                                validation={{ required: true }}
                                                setValue={setValue}
                                                register={register}
                                                errors={formState.errors}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col lg={12} sm={12}>
                                        <Form.Group className="mt-2">
                                            <FormInput
                                                name={'sortCodeIds'}
                                                label="Sort codes in Group:"
                                                type="select"
                                                placeholder="Select sort codes"
                                                containerClass="col-12"
                                                register={register}
                                                validation={{ required: true }}
                                                selectStyle={{
                                                    isMulti: true,
                                                    hideDropDownIndicator: true,
                                                }}
                                                options={companySortCodeOptions}
                                                setValue={setValue}
                                                selectValue={watch('sortCodeIds')}
                                                errors={formState.errors}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>

                                <Row className="align-items-center save-for-future-deliveries justify-content-end">
                                    <Col xs="auto">
                                        <ButtonWithLoading
                                            isLoading={loading}
                                            disabled={loading}
                                            type="submit"
                                            className="btn btn-sm btn-rounded btn-secondary btn-create-new-rule">
                                            {props.payload ? 'Update sort group' : 'Add new sort group'}
                                        </ButtonWithLoading>
                                    </Col>
                                </Row>
                            </Form>
                        </Row>
                    </Card.Body>
                </Card>
            </Modal.Body>
        </Modal>
    );
};

export default AddSortCodeConfig;